import { ThemeUIStyleObject } from "theme-ui";
import { cssTransitions } from "@styles/design-tokens/09.transitions/transitions";

export const CardStyles: ThemeUIStyleObject = {
  width: "100%",
  height: "100%",
  borderRadius: "lg",
  overflow: "hidden",
  backgroundColor: "darkGray",
  "a .lazyload-wrapper": {
    transition: cssTransitions.standard,
  },
  "a:hover .lazyload-wrapper": {
    transform: "scale(1.03)",
  },
};

export const CardLinkStyles: ThemeUIStyleObject = {};

export const CardRedbgStyles: ThemeUIStyleObject = {
  backgroundColor: "darkRed",
};

export const CardGreenbgStyles: ThemeUIStyleObject = {
  backgroundColor: "darkGreen",
};

export const CardInnerStyles: ThemeUIStyleObject = {
  display: "flex",
  alignItems: "flex-start",
  justifyContent: "flex-end",
  py: 6,
  px: 6,
  flexDirection: "column",
  height: "100%",
  width: "100%",
  color: "white",
  zIndex: 2,
  position: "relative",
};

export const ThreeLeafStyles: ThemeUIStyleObject = {
  position: "absolute",
  left: "50%",
  top: ["10%", "10%", "15%"],
  transform: "translateX(-50%)",
  width: "64px",
  height: "59px",
  fill: "lightGray",
  opacity: "0.15",
};
export const ThreeLeafRedStyles: ThemeUIStyleObject = {
  fill: "#060606",
  opacity: "0.3",
};

export const CardAspectRatioGradientStyles: ThemeUIStyleObject = {
  position: "absolute",
  bottom: 0,
  width: "100%",
  minHeight: "50%",
  display: "flex",
  alignItems: "flex-end",
  backgroundImage:
    "linear-gradient(0deg, rgba(0,0,0,0.9) 0%, rgba(0,0,0,0) 100%)",
};
export const CardAspectRatioStyles: ThemeUIStyleObject = {
  position: "relative",
  width: "100%",
  height: "100%",
};
export const CardSplashStyles: ThemeUIStyleObject = {
  position: "absolute",
  top: ["90px"],
  right: 0,
  zIndex: 10,
  py: 3,
  px: 3,
  width: ["200px"],
  p: {
    margin: 0,
    padding: 0,
  },
  textAlign: "center",
  fontSize: "paragraphSmall",
  fontFamily: "heading",
  whiteSpace: "nowrap",
  transform: "rotate(45deg)",
  transformOrigin: "bottom right",
};

export const CardSplashBottomStyles: ThemeUIStyleObject = {
  left: 0,
  bottom: ["90px"],
  top: "auto",
  right: "auto",
  transform: "rotate(45deg)",
  transformOrigin: "top left",
};

export const CardParagraphTextStyles: ThemeUIStyleObject = {
  p: { fontFamily: "heading" },
};
